import {ClassAttributes, Component} from "preact";
import {classNames} from "../classNames";
import {ClassProps} from "../types";
import style from "./Icon.module.css";

export class Icon extends Component<ClassProps> {
	render() {
		return (
			<i class={classNames(style.icon, this.props.class)}>
				{this.props.children}
			</i>
		);
	}
}
